import React from "react";
import { Datagrid, List, TextField, useRecordContext } from "react-admin";
import { LogRecord, Message } from "../../models";
import { Box } from "@mui/material";

export const LogsList = ({
  runId,
  userId,
  date,
}: {
  runId: string | undefined;
  userId: string;
  date?: string | undefined;
  message: Message;
}) => {
  if (!userId || !runId || !date) {
    return null;
  }

  const ExpandedBody = () => {
    const record = useRecordContext();
    if (!record) return null;
    return (
      <Box
        sx={{
          p: 2,
          whiteSpace: "pre-wrap", // keep \n and spaces
          wordBreak: "break-word", // wrap long words
          fontFamily:
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        }}
      >
        {record.value}
      </Box>
    );
  };

  const ValueField = (props: any) => {
    const record: LogRecord = useRecordContext();
    if (!record) return null;

    if (record && record.id === "Trace ID") {
      return (
        <a
          href={`https://eu-west-2.console.aws.amazon.com/cloudwatch/home?region=eu-west-2#xray:traces/${record.value}`}
          target="_blank"
          rel="noreferrer"
          title="Open in AWS CloudWatch X-Ray"
        >
          {record.value}
        </a>
      );
    }

    return <TextField {...props} />;
  };

  return (
    <List
      resource={`/admin/users/${userId}/runs/${runId}/logs`}
      pagination={false}
      exporter={false}
      title="Details"
      filter={{ date }}
    >
      <Datagrid
        expand={<ExpandedBody />}
        expandSingle
        bulkActionButtons={false}
        sx={{
          "& .RaDatagrid-row": { verticalAlign: "top" },
          "& .MuiTableCell-root": { verticalAlign: "top" },
        }}
      >
        <TextField source="id" label="Key" sortable={false} />
        <ValueField
          source="valueTrimmed"
          label="Value"
          sortable={false}
          sx={{
            whiteSpace: "pre-wrap", // keep \n and spaces
            wordBreak: "break-word", // wrap long words
            fontFamily:
              'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          }}
        />
      </Datagrid>
    </List>
  );
};
